import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';

export interface AppNotification {
  id: string;
  actorId: string | null;
  type: string;
  body: string;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export function useUnreadCount() {
  return useQuery({
    queryKey: ['notif-unread'],
    queryFn: () => api.get<{ count: number }>('/api/notifications/unread-count').then((r) => r.count),
    refetchInterval: 30_000,
  });
}

export function useNotifications(enabled: boolean) {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get<AppNotification[]>('/api/notifications'),
    enabled,
  });
}

export function useMarkAllRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('/api/notifications/read-all', {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['notif-unread'] });
      qc.invalidateQueries({ queryKey: ['notifications'] });
    },
  });
}
